module.exports = __webpack_public_path__ + "img/smb_rect.10a1afe7.svg";